import React from 'react';
import { CTAButton } from '../CTAButton';
import { CountdownTimer } from '../CountdownTimer';
import { ScarcityBar } from '../ScarcityBar';
export function FinalCTA() {
  return <section className="w-full bg-navy-950 px-4 py-16 pb-28 sm:py-20 sm:pb-32" data-id="element-156" data-mp="3mts32kejgz7o">
      <div className="mx-auto w-full max-w-2xl text-center" data-id="element-157" data-mp="3mrxpxs9iebe5">
        <h2 className="font-display text-[26px] font-black leading-tight tracking-tight text-white sm:text-4xl" data-id="element-158" data-mp="3rrk2s0lfdpmf">
          ¿Estás listo para dejar de improvisar cada vez que un paciente con
          hipotiroidismo entra a tu consulta?
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-[15px] leading-relaxed text-navy-100/75 sm:text-lg" data-id="element-159" data-mp="33uw7p5qy2es9">
          Empieza hoy mismo a utilizar el sistema que ya ha ayudado a miles de
          médicos a tomar decisiones con mayor rapidez, seguridad y respaldo
          clínico.
        </p>

        <div className="mt-8 rounded-3xl bg-white p-5 sm:p-7" data-id="element-160" data-mp="121q8m0vjvf53">
          <CTAButton label="QUIERO LA RUTA HIPOTIROIDISMO POR USD $15" data-id="element-161" data-mp="171b3o07ln3cj" />
          <CountdownTimer data-id="element-162" data-mp="q7tzjitrscf9" />
          <p className="mt-4 text-[11px] font-medium leading-relaxed text-navy-700/70 sm:text-sm" data-id="element-163" data-mp="q72daym2br1n">
            Descarga inmediata · Pago único · Acceso de por vida · Garantía de 7
            días
          </p>
          <div className="mt-5" data-id="element-164" data-mp="z05m2tlrjfpy">
            <ScarcityBar data-id="element-165" data-mp="uzc38en6gr3x" />
          </div>
          <p className="mt-4 text-[12px] leading-relaxed text-navy-700/70 sm:text-sm" data-id="element-166" data-mp="v0n3w5lbtiqt">
            💳 El cambio de moneda es automático: paga en la moneda de tu país
            al tipo de cambio vigente.
          </p>
        </div>
      </div>
    </section>;
}